import { Tooltip } from "@/components/ui/tooltip";
import type { NotificationTypeListItem } from "@/services/notification-types.service";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";

interface Props {
  item: NotificationTypeListItem;
  handleView: (item: NotificationTypeListItem) => void;
}

export const NotificationTypesActions = ({ handleView, item }: Props) => {
  return (
    <Tooltip
      showArrow
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={
        <Text color={AppColors.WHITE_SECONDARY} fontSize="14px">
          Ver
        </Text>
      }
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <Eye size="20px" cursor="pointer" onClick={() => handleView(item)} />
      </Flex>
    </Tooltip>
  );
};
